import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { autobind } from 'core-decorators';
import { delay, noop } from '@src/utils/common-util';
import InputStore from '@src/pages/main/components/appointment-modal/components/input/store';
import { validPhoneNumberRegex } from '@src/constants/regex';
import { useEffect } from 'react';
import { useCountDown, useUnmount } from 'ahooks';
import Service from './service';
import * as Scroll from 'react-scroll';
import { useRequest } from 'ahooks';
import lockAsync from '@src/utils/lock-async';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import getUtmSource from '@src/utils/get-utm-source';
// import AntdMessage from '@src/components/antd/message';
import Toast from '@src/components/toast';
import OverseasStore from './overseas/store';

import { isIOS } from 'detect-mobile-device';
import { getLocales } from '@src/global-locales/get-page-locales-data';

/**
 * 预约类型
 * @type {{PC: number, 主机: number}}
 */
export const APPOINTMENT_TYPE = {
  PC: 1,
  主机: 2
};

class AppointmentModalStore {
  onClose = noop;
  /**
   * 是否正在加载中
   * @type {boolean}
   */
  @observable isLoading = false;
  @observable isLockBtn = false;
  /**
   * 是否预约成功
   * @type {boolean}
   */
  @observable isAppointmentSuccess = false;

  // 是否是新预约
  @observable is_new = false;

  /**
   * 协议抖动
   * @type {boolean}
   */
  @observable protocolShaking = false;
  /**
   * 弹窗是否打开
   * @type {boolean}
   */
  @observable isOpen = false;
  /**
   * 当前选择的预约类型
   * @type {number}
   */
  @observable currentAppointmentType = APPOINTMENT_TYPE.PC;
  /**
   * 是否已经同意协议
   * @type {boolean}
   */
  @observable isAgreementProtocol = false;

  utmSource = getUtmSource();
  //弹出公共提示弹
  @observable showCommonModal = noop;
  //更新config
  @observable updataConfig = noop;

  /**
   * inputStore集合
   * @type {{smsInput: InputStore, phoneInput: InputStore}}
   */
  inputStores = {
    phoneInput: new InputStore({
      maxLength: 11,
      onBlurToTop: isIOS() ? this.onBlurToTop : '',
      validator: function (isSmsCodeInputBtn = false) {
        if (!this.valueStore.value) {
          this.isError = true;
          this.errorMessage = '手机号码不得为空';
          throw new Error('手机号码不得为空');
        }
        if (!validPhoneNumberRegex.test(this.valueStore.value)) {
          this.isError = true;
          this.errorMessage = '手机号码格式不正确';
          throw new Error('手机号码不得为空');
        }
      }
    }),
    smsInput: new InputStore({
      maxLength: 6,
      onBlurToTop: isIOS() ? this.onBlurToTop : '',
      validator: function () {
        if (!this.valueStore.value) {
          this.isError = true;
          this.errorMessage = '验证码不得为空';
          throw new Error('验证码不得为空');
        }
      }
    })
  };
  /**
   * 倒计时关闭时间
   * @type {number}
   */
  @observable countdown = 5;

  constructor(options = {}) {
    // super();
    Object.assign(this, options);
  }

  @autobind
  onSelectAppointmentTypeChange(value) {
    this.currentAppointmentType = value;
  }
  onBlurToTop() {
    Scroll.scroller.scrollTo('index', {
      duration: 0,
      delay: 0,
      smooth: true,
      offset: -50 // Scrolls to element + 50 pixels down the page
    });
  }

  /**
   * 点击关闭时回调
   */
  @autobind
  onCloseHandler() {
    this.isOpen = false;
    this.onClose();
  }

  @autobind
  onAgreeProtocolChange() {
    this.isAgreementProtocol = !this.isAgreementProtocol;
  }

  /**
   * 提交表单
   */
  @autobind
  async onSubmit() {
    try {
      if (this.isLoading || this.isLockBtn) {
        return;
      }
      this.isLockBtn = true;
      const _storeArr = Object.keys(this.inputStores);
      _storeArr.forEach(store => {
        this.inputStores[store].validator();
      });
      if (!this.isAgreementProtocol) {
        // this.protocolShaking = true;
        // AntdMessage.info('请先勾选同意隐私条款');
        // AntdMessage.error('请先勾选同意隐私条款');
        Toast.info(getLocales('reserve.logic.need_agreement'));
        return;
      }
      const _code = this.inputStores.smsInput.valueStore.value;
      const _phone = this.inputStores.phoneInput.valueStore.value;
      const _from = 'default';
      const _utm_source = this.utmSource;
      const res = await this.submiteRequest.run({ code: _code, from: _from, phone: _phone, _utm_source: _utm_source, pass_check: 1 });
    } catch (err) {
      // AntdMessage.error(err.message);
      Toast.info(err.message);
      // console.log(err.message);
    } finally {
      await delay(300);
      this.isLockBtn = false;
    }
  }

  @autobind
  phoneInputValidator() {
    this.inputStores.phoneInput.validator();
  }

  @autobind
  @lockAsync()
  @captchaHandlerDecorate('zt')
  async onSendVCRequest({ ...authParams }) {
    try {
      const res = await this.sendCodeRequest.run({ ...authParams });
      // AntdMessage.success('验证码已发送, 请注意查收');
      // this.smsInputStore.elementRef?.current.focus();
      return true;
    } catch (err) {
      if (err?.serviceResponse /**属于业务请求异常*/) {
        const { code, msg } = err.serviceResponse;
        // AntdMessage.error(msg);
        Toast.info(msg);
      } else if (err.message) {
        Toast.info(err.message);
      }

      return false;
    }
  }

  setTargetDate = noop;

  /**
   * 发送短信验证码
   * @param params
   * @returns {*}
   */
  sendCodeAsync = params => {
    const { phone, ...restParams } = params || {};
    return Service.sendCodeAsync({ phone: phone, ...restParams, pass_check: 1 }).catch(err => {
      if (err?.serviceResponse /**属于业务请求异常*/) {
        const { code, msg } = err.serviceResponse;
        // AntdMessage.error(msg);
        Toast.info(msg);
        // this.showCommonModal('提示', msg);
      } else if (err.message) {
        Toast.info(err.message);
        // this.showCommonModal('提示', err.message);
        // AntdMessage.error(err.message);
      }
      throw err;
    });
  };

  /**
   * 预约
   * @param params
   * @returns {*}
   */
  submitAsync = params => {
    return Service.submitAsync(params)
      .then(async res => {
        this.is_new = !!res.is_new;
        this.isAppointmentSuccess = true;
        this.updataConfig();
        this.setTargetDate(Date.now() + 5000);
      })
      .catch(err => {
        const { code, msg } = err.serviceResponse;
        // this.showCommonModal('提示', msg);
        Toast.info(msg);
        throw err;
      });
  };

  use() {
    const [countdown, setTargetDate] = useCountDown({ onEnd: this.onCloseHandler });
    /**
     * 获取验证码
     * @type {BaseResult<any, []>}
     */
    this.sendCodeRequest = useRequest(async params => await this.sendCodeAsync(params), { manual: true });
    /**
     * 预约提交
     * @type {BaseResult<any, []>}
     */
    this.submiteRequest = useRequest(async params => await this.submitAsync(params), {
      manual: true,
      throwOnError: true
    });
    this.setTargetDate = setTargetDate;
    useEffect(
      () => {
        this.countdown = countdown;
      },
      [countdown]
    );
    useMount(() => {
      this.isOpen = true;
      this.setTargetDate(undefined);
    });
    /**
     * 用于解除协议的抖动动画提示
     */
    useEffect(
      () => {
        if (this.protocolShaking) {
          setTimeout(() => {
            this.protocolShaking = false;
          }, 300);
        }
      },
      [this.protocolShaking]
    );
    useUnmount(() => {
      this.isAppointmentSuccess = false;
      this.inputStores.phoneInput.valueStore.value = '';
      this.inputStores.smsInput.valueStore.value = '';
      this.isAgreementProtocol = false;
      this.protocolShaking = false;
    });
    useEffect(
      () => {
        this.isLoading = this.submiteRequest.loading;
      },
      [this.submiteRequest.loading]
    );
  }
}

export default OverseasStore;
